import { Variable } from '../../deployments/models/VariableGroup';

export function GetVariableValueByKey(variables: Variable[], key: string): string {
  if (!variables[key]) {
    console.warn(`key '${key}' does not exist in ${JSON.stringify(variables)}.`);
  }
  return variables[key]?.value;
}
